import { render, staticRenderFns } from "./ApiM.vue?vue&type=template&id=928e3194&scoped=true"
import script from "./ApiM.vue?vue&type=script&lang=js"
export * from "./ApiM.vue?vue&type=script&lang=js"
import style0 from "./ApiM.vue?vue&type=style&index=0&id=928e3194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928e3194",
  null
  
)

export default component.exports